'use strict';

import 'angular';

import submitDirective from './directive';

const MODULE_NAME = 'brg.rest.buttons.submit';

var app = angular.module(MODULE_NAME, []);
app.directive('brgRestSubmit', submitDirective);

export default MODULE_NAME;
